import React, { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { HeaderFilter } from "../../../common/header-filter/header-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import { ListTabButton } from "../../../common/list-tab/list-tab-button.component";
import { Header_Filter_Button_Label, Selected_Index } from "../../../../constants/internal-constants";
import GlCodeDetails from "./details/cost-gl-code-details.component";
import CostCodeDetails from "./details/cost-code-details.component";
export class CostCode extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedIndex:"0",
            listSelected:"Cost Center",
        }
    }

    getData=(value)=>{
		this.setState({viewDetailPage:value})
	}

    filterIndex(tabIndex){    
        this.setState({selectedIndex:tabIndex});  
       
    }

    filterList=(value)=>{
        this.setState({listSelected:value})
    }

    render() {
        const dropdownItem = ["Item 1", "Item 2", "Item 3"]
        const dataTable = [
            {
                HeaderItem: [
                    {
                        name: "Contract Name"
                    },
                    {
                        name: "Vendor"
                    }, {
                        name: "Status"
                    }, {
                        name: "Service Type"
                    }, {
                        name: "Effective Date"
                    }, {
                        name: "Expiration Date"
                    }
                ],
                dataItem: [{
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }, {
                    columnItem1: "3G Hutchison (GB) Contract",
                    columnItem2: "3G Hutchison (GB)",
                    columnItem3: "Expired",
                    columnItem5: "May 29, 2021",
                    columnItem6: "May 15, 2022",
                    columnItem7: "May 15, 2022",
                }
                ]

            }
        ]
        const pages = {
            HasNext: true,
            HasPrevious: false,
            PageNumber: 0,
            PerPage: 21,
            TotalEntries: 2453,
            TotalPages: 123

        }
        const listItem = [
            {
                listTitle: "Plan",
                href: "#"
            }
            , {
                listTitle: "Feature"
                , href: "#"
            }
            , {
                listTitle: "Rate"
                , href: "#"
            }
        ];
        const listTabInfo={
            Tab:[
                {
                    "id":"0",
                    "label":"Cost Center"            
                },
                {
                    "id":"1",
                    "label":"GL Code"           
                }
            ]
        };
        const buttonTitle=this.state.selectedIndex===Selected_Index.i_Zero ? Header_Filter_Button_Label.AddCostCode : Header_Filter_Button_Label.AddGlCode
        return (
            <>
                <RequestHeaders headerTitle="Cost Code" />              
               {
                !this.state.viewDetailPage &&
                <div className="request-table data-table internal-data-table">
                        <ListTabButton listData={listTabInfo.Tab} filterList={this.filterList} selectedIndex={this.props.haveTotalDetail ? this.state.selectedTab : this.state.selectedIndex} FilterIndex={this.filterIndex.bind(this)}/>                  
                
                        <HeaderFilter enableDropdown={true} dropdownItem={dropdownItem} filterList={this.filterList} enableExportExcel={false} btnAddTitle={buttonTitle} enableAddBtn={true} enableUploadBtn={false} listItem={listItem} haveTab={false} />               

                    { dataTable.map((item, id) =>
                        <DataTable key={id} id={id} item={item} header={item.HeaderItem} getData={this.getData} data={item.dataItem} isDataLoaded={true} customClassName="table-container" pages={pages} havePagination={true} />
                    )}
                    
                </div>  
               }

                {this.state.viewDetailPage && this.state.selectedIndex===Selected_Index.i_Zero  && 

                    <CostCodeDetails closeForm={this.getData.bind(this)} />

                } 

                {this.state.viewDetailPage && this.state.selectedIndex===Selected_Index.i_One  && 
                    <GlCodeDetails closeForm={this.getData.bind(this)} />
                }             
            </>
        )
    }
}